import React from 'react';
import { Box, IconButton } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useFirebase } from '../contexts/FirebaseContext';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import editPhotoIcon from '../assets/images/icon-edit-photo.svg';
import ProfileImage from './ProfileImage';

const ProfilePhotoManager = () => {
  const { userProfile, updateUserProfile } = useAuth();
  const { storage } = useFirebase();

  const handlePhotoUpload = async (e) => {
    try {
      const file = e.target.files[0];

      if (!file) return;
      const fileExtension = file.name.split('.').pop();
      const storageRef = ref(
        storage,
        `profile_images/${userProfile.uid}/profile_image.${fileExtension}`
      );

      uploadBytes(storageRef, file).then((snapshot) => {
        getDownloadURL(storageRef)
          .then((url) => {
            return updateUserProfile({
              ...userProfile,
              profileImage: url,
            });
          })
          .catch((error) => {
            console.error('Error getting download URL:', error);
          });
      });
    } catch (error) {
      console.error('Error uploading photo:', error);
    }
  };

  const handleRemovePhoto = async () => {
    let fileExtension = '';
    try {
      fileExtension = userProfile?.profileImage?.split('.').pop().split('?')[0];
    } catch (error) {
      return console.error('Error removing photo:', error);
    }
    const storageRef = ref(
      storage,
      `profile_images/${userProfile.uid}/profile_image.${fileExtension}`
    );

    try {
      deleteObject(storageRef)
        .then(async () => {
          await updateUserProfile({
            ...userProfile,
            profileImage: null,
          });
        })
        .catch((error) => {
          console.error('Error removing photo:', error);
        });
    } catch (error) {
      console.error('Error removing photo:', error);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mb: 1,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '150px',
          height: '150px',
          mb: 2,
        }}
      >
        <ProfileImage />
        {!userProfile?.profileImage ? (
          <IconButton
            variant="contained"
            component="label"
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
              },
            }}
          >
            <img src={editPhotoIcon} alt="Upload" />
            <input type="file" hidden accept="image/*" onChange={handlePhotoUpload} />
          </IconButton>
        ) : (
          <IconButton
            variant="outlined"
            color="error"
            onClick={handleRemovePhoto}
            sx={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
              },
            }}
          >
            <img src={editPhotoIcon} alt="Remove" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ProfilePhotoManager;
